import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { HiMiniXMark } from "react-icons/hi2";
import { LuMenu } from "react-icons/lu";
import { useLocation, useNavigate } from "react-router-dom";

import TabModule from "./TabModule";

import Button from "../Button";
import Dropdown from "../Dropdown";
import ShowSearchBarResult from "../Searchbar";
import Spinner from "../Spinner";

import { bankco, profileImage, recentSearch, rewardIconSvg, search, support } from "../../../assets/svg";

import { useAuth } from "../../../hoc/AuthContext";
import { useFetchModuleData } from "../../../hooks/useFetchModuleData";
import useWindowSize from "../../../hooks/useWindowSize";

import { getPublicSubModule } from "../../../Services/APIs/LandingPage";
import { userDetail } from "../../../Services/APIs/RewardListing";

import { backgroundColor, defaultTextColor, getDynamicBackgroundImageUrl, getSubdomainInfo, isPublicPage, newTheme, showLoyaltyPoint, textColor } from "../../../Utils/CommonFunctions";
import { MODULETABS } from "../../../Utils/Constant";

import { CONTACT_US_PAGE, HOMEPAGE } from "../../../Routes/RoutesContant";

import Login from "../../LoginSignup";
import SignUp from "../../LoginSignup/SignUp";

import { useIntegratorFonts } from "../../../hooks/useIntegratorFonts";
import Alert from "../Alert";
import RenderCreditCardDropDown from "./RenderCreditCardDropDown";

export default function Header({ theme }) {
  const [showSearchbarMoblie, setShowSearchBarMobile] = useState(false);
  const [showMenuMoblie, setShowMenuMobile] = useState(false);
  const [user, setUser] = useState({});
  const [userCardInfo, setUserCardInfo] = useState({});
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [cards, setCards] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  // search bar
  const [searchTerm, SetSearchTerm] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchresult, setSearchResult] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [recentSearchesState, setRecentSearchesState] = useState(JSON.parse(localStorage.getItem('recentSearches')) || []);

  const PublicPage = isPublicPage();
  const { isSubdomain } = getSubdomainInfo();
  const navigate = useNavigate();
  const { isAuthenticated, logout, setCardInfo, selectedCardData, setSelectedCardData, setUserData, showLogin, setShowLogin,
    setIsCardChange, setSubVarientIdGlobal, integratorTheme, setIntegratorTheme, setCreditCard, setModuleInfo, setAllSubModuleInfo,
    subVarientIdGlobal, setLandingPageSection, setShowSignUp, showSignUp } = useAuth();

  const { fetchPublicSubModuleData, fetchPrivateSubModuleData, fetchPublicModuleData } = useFetchModuleData(setModuleInfo,
    setAllSubModuleInfo, subVarientIdGlobal, setLandingPageSection, setAlert);

  // theme font 
  useIntegratorFonts(integratorTheme);
  const isMobile = useWindowSize();

  const dynamicPathwayImageUrl = getDynamicBackgroundImageUrl(integratorTheme?.pathway, isMobile);
  const isLoyalityAvailable = showLoyaltyPoint(integratorTheme);
  const location = useLocation();

  const drawerLoginRef = useRef(null);
  const drawerSignUpRef = useRef(null);
  const resultsRef = useRef(null);
  const dropdownRef = useRef(null);

  // Module Tab section 
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (alert) {
      setTimeout(() => {
        setAlert({ show: false, message: '', type: '' });
      }, 5000);
    }
  }, [alert]);

  useEffect(() => {
    const initializeData = async () => {
      const subId = localStorage.getItem('rewardSubId');
      if (PublicPage && subId) {
        await fetchPublicModuleData(subId);
      } else {
        if (isAuthenticated) {
          // First fetch user data
          const result = await fetchUserData();
          // Now that user data is fetched and subVarientIdGlobal is set, fetch the modules
          await fetchPrivateSubModuleData(result);
        } else {
          fetchPublicSubModuleData();
        }
      }
    };

    initializeData();
  }, [isAuthenticated, fetchPrivateSubModuleData, fetchPublicSubModuleData]);

  useEffect(() => {
    // Get the first segment of the current path
    const currentPath = location.pathname.split("/")[1];

    // Find the matching tab based on the path
    const matchedTab = MODULETABS.find((tab) => tab.path === currentPath);

    // Set active tab
    setActiveTab(matchedTab ? matchedTab.id : null);
  }, [location.pathname, MODULETABS]);

  useEffect(() => {
    if (showLogin) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showLogin]);

  useEffect(() => {
    if (showSignUp) {
      document.addEventListener("mousedown", handleSignUpClickOutside);
    } else {
      document.removeEventListener("mousedown", handleSignUpClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleSignUpClickOutside);
    };
  }, [showSignUp]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideDropDown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDropDown);
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated && !PublicPage) {
      fetchUserData();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isSubdomain) {
      fetchIntegratorData();
    } else {
      setIntegratorTheme(newTheme);
    }
  }, [isSubdomain]);

  const fetchIntegratorData = async () => {
    setLoading(true);
    try {
      const result = await getPublicSubModule();
      if (result?.status === 200) {
        setIntegratorTheme(result?.data);
        setLandingPageSection(result?.data?.landing_page_sections);
        // setIntegratorTheme(newTheme);
      }
    } catch (e) {
      console.log(e);
      setIntegratorTheme(newTheme);
    } finally {
      setLoading(false);
    }
  };

  const handleShowLogin = () => {
    setShowLogin(!showLogin);
    setShowSignUp(false);
    setShowSearchBarMobile(false);
    setShowMenuMobile(false);
    setShowSearchBar(false);
    SetSearchTerm('');
    setSearchResult(null);
  };

  const handleShowSignUp = () => {
    setShowSearchBarMobile(false);
    setShowLogin(false);
    setShowSignUp(!showSignUp);
    setShowMenuMobile(false);
    setShowSearchBar(false);
    SetSearchTerm('');
    setSearchResult(null);
  };

  const handleClickOutside = (event) => {
    if (drawerLoginRef.current && !drawerLoginRef.current.contains(event.target)) {
      setShowLogin(false);
      setCardInfo(null);
      setShowSearchBar(false);
      SetSearchTerm('');
    }
  };

  const handleSignUpClickOutside = (event) => {
    if (drawerSignUpRef.current && !drawerSignUpRef.current.contains(event.target)) {
      setShowSignUp(false);
      setCardInfo(null);
      setShowSearchBar(false);
      SetSearchTerm('');
    }
  };

  const fetchUserData = async () => {
    try {
      const result = await userDetail();

      if (result.status === 200) {
        setUser(result?.data?.user);
        setCreditCard(result?.data?.cards)
        const filterCardInfo = result?.data?.cards?.filter((item) => item?.is_default);
        const selectedCard = selectedCardData?.sub_variant?.id
        localStorage.setItem("subId", selectedCard ? selectedCard : filterCardInfo?.[0]?.sub_variant?.id);
        setUserCardInfo(filterCardInfo?.[0]);
        setUserData(result?.data?.user);
        setCards(result?.data?.cards);
        return selectedCard
      }
    } catch (e) {
      if (e.status === 403) {
        logout();
        navigate("/");
      }
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/");
    setIsOpenDrawer(false);
    setShowMenuMobile(false);
    setShowSearchBar(false);
    SetSearchTerm('');
  };

  // selected card change function 
  const handleCardClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleCardSelect = (card) => {
    setSelectedCardData(card);
    setIsCardChange(true);
    setSubVarientIdGlobal(card?.sub_variant?.id);
    localStorage.setItem("selectedCard", JSON.stringify(card));
    localStorage.setItem("subId", JSON.stringify(card?.sub_variant?.id));
    setShowDropdown(false);
  };

  const handleClickOutsideDropDown = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };
  const cardDataToShow = Object.keys(selectedCardData).length === 0 ? userCardInfo : selectedCardData;

  const handleNavigation = (path) => {
    setIsOpenDrawer(false);
    navigate(path);
    if (isMobile) setShowMenuMobile(false);
  };

  const handleModuleClick = (tab) => {
    setActiveTab(tab.id);
    setIsOpenDrawer(false);
    if (isMobile) setShowMenuMobile(false);
  }

  function renderDropDownHeader() {
    return (
      <div className="py-0 profile_dropdown">
        <span className="cursor-pointer">
          <img src={profileImage} alt={user?.name} />
        </span>
      </div>
    );
  }

  function renderDropDownBody() {
    return (
      <>
        <div className={`bg-[#F3F3F3] flex gap-4 items-start truncate text-lg font-Inter border-[#BDBDBD] border rounded-t-[20px] ${isMobile ? "w-full py-4 container mx-auto px-5" : "w-[308px] p-4"} `}>
          <img src={profileImage} alt={user?.name} />
          <div className="flex flex-col text-wrap">
            Hello {user?.name},
            <div style={{ color: defaultTextColor(integratorTheme) }} className={`font-semibold`}>
              {user?.mobile_number}
            </div>
          </div>
        </div>

        <div className={`flex flex-col gap-4 md:gap-6 ${isMobile ? "py-6 container mx-auto px-5" : "p-6"} font-Inter font-semibold text-[16px]`}>
          <div className="md:hidden block">
            <TabModule
              handleModuleClick={handleModuleClick}
              activeTab={activeTab}
              theme={theme}
            />
          </div>
          <div className="md:hidden flex items-start rounded-[10px] gap-2 relative cursor-pointer" onClick={handleCardClick} ref={dropdownRef}>
            <img src={cardDataToShow?.sub_variant?.logo || cardDataToShow?.sub_variant?.payment_network?.logo} alt={cardDataToShow?.sub_variant?.name}
              className="w-6 h-6 object-contain" loading="lazy" />

            <div className="font-medium flex items-center justify-between w-full">
              {cardDataToShow?.sub_variant?.bank?.display_name !== "*" && `${cardDataToShow?.sub_variant?.bank?.display_name} `}
              {cardDataToShow?.sub_variant?.name !== "*" && `${cardDataToShow?.sub_variant?.name} `}
              {cardDataToShow?.sub_variant?.payment_network?.name !== "*" && `${cardDataToShow?.sub_variant?.payment_network?.name} `}
              {cardDataToShow?.sub_variant?.variant?.name !== "*" && cardDataToShow?.sub_variant?.variant?.name}
            </div>
            {showDropdown ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
            {showDropdown && (
              <div className="absolute h-[200px] overflow-y-auto top-full left-0 mt-2 bg-white z-10 w-full">
                {cards.map((card) => (
                  <div key={card.id} className="p-2 text-sm cursor-pointer hover:bg-gray-200" onClick={() => handleCardSelect(card)}>
                    {card?.sub_variant?.bank?.display_name !== "*" && `${card?.sub_variant?.bank?.display_name} `}
                    {card?.sub_variant?.name !== "*" && `${card?.sub_variant?.name} `}
                    {card?.sub_variant?.payment_network?.name !== "*" && `${card?.sub_variant?.payment_network?.name} `}
                    {card?.sub_variant?.variant?.name !== "*" && card?.sub_variant?.variant?.name}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="cursor-pointer" onClick={() => handleNavigation('/userProfile/assignedOffer')}>
            Assigned Offers
          </div>
          <div className="cursor-pointer" onClick={() => handleNavigation('/userProfile')}>
            Profile
          </div>
          <div className="cursor-pointer" onClick={() => handleNavigation('/userProfile/order')}>
            Orders
          </div>

          {isLoyalityAvailable && (
            <div className="flex cursor-pointer justify-between w-full pr-4" onClick={() => handleNavigation('/userProfile/reward')}>
              <div>Loyality Points</div>

              <div className="flex gap-1">
                <img src={rewardIconSvg} alt="rewardIconSvg" />
                <div>{user?.points}</div>
              </div>
            </div>
          )}

          <div onClick={() => handleLogout()} className="cursor-pointer hover:rounded-b-[20px]">
            Logout
          </div>
        </div>
      </>
    );
  }

  function renderAunthenticatedWebView() {
    return (
      <div className={`md:flex gap-3.5 ${isAuthenticated ? "w-[50px] h-[50px]" : "w-auto"} hidden`}>
        {isAuthenticated ? (
          <Dropdown
            dropDownHeader={renderDropDownHeader}
            dropdownBody={renderDropDownBody}
            isOpenDrawer={isOpenDrawer}
            setIsOpenDrawer={setIsOpenDrawer}
            isShowIcon={false}
            isHeader={true}
          />
        ) : (
          <>
            <Button theme={integratorTheme} variant="secondary" size="sm" className="h-auto px-5 py-3 w-auto font-medium text-base" onClick={handleShowLogin} >
              Sign In
            </Button>

            <Button variant="primary" size="sm" theme={integratorTheme} className={`h-auto px-5 py-3 w-auto text-base font-medium`} onClick={handleShowSignUp}>
              Sign Up
            </Button>
          </>
        )}
      </div>
    );
  }

  function renderMobileViewHeaderOption() {
    return (
      <div className="flex md:hidden gap-4">
        <div className="bg-[#F7F7F7] flex justify-center items-center w-12 h-12 p-3 rounded-md cursor-pointer">
          {showSearchbarMoblie
            ? <HiMiniXMark color="#3B3E63" size={26}
              onClick={() => {
                setShowMenuMobile(false);
                setShowSearchBarMobile(false);
                SetSearchTerm('');
                setShowSearchBar(false);
                setSearchResult(null);
              }}
            />
            : <img src={search} alt="search" loading="lazy"
              onClick={() => {
                setShowMenuMobile(false);
                setShowSearchBarMobile(true);
                SetSearchTerm(searchTerm);
                setShowSearchBar(true)
              }}
            />
          }
        </div>

        <div
          style={{ backgroundColor: backgroundColor(integratorTheme) }}
          className={`w-12 h-12 p-3 rounded-md cursor-pointer`}
          onClick={() => {
            setShowMenuMobile(!showMenuMoblie);
            setShowSearchBarMobile(false);
            setShowSearchBar(false);
            SetSearchTerm('');
            setSearchResult(null);
          }}
        >
          {showMenuMoblie
            ? <HiMiniXMark color={textColor(integratorTheme)} size={26} />
            : <LuMenu color={textColor(integratorTheme)} size={26} />
          }
        </div>
      </div>
    );
  }

  function renderMobileSearchBarView() {
    const isPublicPathwayStyling = PublicPage && integratorTheme?.pathway;

    return (
      <>
        {showSearchbarMoblie && showSearchBar && (
          <div className={`${isPublicPathwayStyling ? "" : ""} container mt-2 px-5 relative z-0 mx-auto ${showSearchbarMoblie && isMobile ? "flex" : "hidden"}`}>
            <ShowSearchBarResult
              setSearchResult={setSearchResult}
              searchTerm={searchTerm}
              SetSearchTerm={SetSearchTerm}
              setSearchLoading={setSearchLoading}
              setShowSearchBar={setShowSearchBar}
              showSearchBar={showSearchBar}
              searchresult={searchresult}
              setRecentSearchesState={setRecentSearchesState}
              recentSearchesState={recentSearchesState}
              resultsRef={resultsRef}
              recentSearch={recentSearch}
              searchLoading={searchLoading}
              setShowMenuMobile={setShowMenuMobile}
              setShowSearchBarMobile={setShowSearchBarMobile}
            />
          </div>
        )}
      </>
    );
  };

  function renderMobileMenubarView() {
    return (
      showMenuMoblie && (
        <div className={`relative font-Inter mt-2.5 z-0 shadow-lg ${theme === "rewards" ? "rounded-[20px]" : ""} bg-white w-full mx-auto ${showMenuMoblie && isMobile ? "flex flex-col" : "hidden"}`}>
          {isAuthenticated ? renderDropDownBody() : (
            <div className="container mx-auto px-5 py-4 flex flex-col gap-4">
              {!PublicPage &&
                <div className="flex justify-between gap-5">
                  <Button theme={integratorTheme} variant="secondary" size="lg" className="w-44 font-medium" onClick={handleShowLogin} >
                    Sign In
                  </Button>
                  <Button theme={integratorTheme} variant="primary" size="lg" className="w-44 font-medium" onClick={handleShowSignUp} >
                    Sign Up
                  </Button>
                </div>
              }
            </div>
          )}
        </div>
      )
    );
  }

  function renderLoginComponent() {
    return (
      showLogin && (
        <div className="container mt-2 px-5 flex mx-auto justify-center md:justify-end">
          <div className={`absolute z-30 container mx-auto md:max-w-md`} ref={drawerLoginRef}>
            <Login setShowLogin={setShowLogin} setShowSignUp={setShowSignUp} />
          </div>
        </div>
      )
    );
  }

  function renderSignUpComponent() {
    return (
      showSignUp && (
        <div className="container mt-2 px-5 flex mx-auto justify-center md:justify-end">
          <div className={`absolute z-30 container mx-auto md:max-w-md`} ref={drawerSignUpRef}>
            <SignUp setShowSignUp={setShowSignUp} setShowLogin={setShowLogin} />
          </div>
        </div>
      )
    );
  }

  return (loading ? <Spinner /> : (
    <>
      <Alert
        message={alert.message}
        show={alert.show}
        setShowAlert={setAlert}
        type={alert.type} // 'success', 'warning', 'error', or 'info'
      />
      <div className={`relative ${theme === "rewards" || theme === "main" || !theme ? "bg-[#fff]" : `bg-[#${integratorTheme?.bank?.hex_code || "fff"}]`}`}>

        {(PublicPage && integratorTheme?.pathway) ? (
          <div className="relative">
            <img
              src={dynamicPathwayImageUrl ? dynamicPathwayImageUrl : integratorTheme?.pathway}
              alt={integratorTheme?.bank?.name} loading="lazy" className="relative z-0" />
            <div className="absolute right-0 top-1 h-full z-10 w-full container px-5 mx-auto flex justify-end items-center">

              <div className="flex items-center gap-5 mt-2.5 md:mt-0">
                {<div className="block relative min-w-4 h-4 md:min-w-5 md:h-5">
                  <img src={search} alt="search" loading="lazy" className="cursor-pointer w-4 h-4 md:w-5 md:h-5" onClick={() => setShowSearchBar(true)} />
                </div>}

                {/* {PublicPage && renderMobileViewHeaderOption()} */}
              </div>
            </div>
          </div>
        ) : (
          <div className={`h-[74px] md:h-[94px] w-full container px-5 mx-auto flex justify-between items-center`}>
            <img src={integratorTheme?.logo || integratorTheme?.bank?.logo || bankco} alt={integratorTheme?.bank?.name || "bankco"} className={`cursor-pointer w-[154px] h-[44px]`} loading="lazy"
              onClick={() => navigate(HOMEPAGE)} />

            <div className="flex items-center gap-5">
              {/* {!PublicPage && !isAuthenticated && (
                <div className="md:block relative hidden min-w-5 h-5">
                  <img src={search} alt="search" loading="lazy" className="cursor-pointer w-5 h-5" onClick={() => setShowSearchBar(true)} />
                </div>
              )} */}

              <div className="md:block relative hidden min-w-5 h-5">
                <img src={search} alt="search" loading="lazy" className="cursor-pointer w-5 h-5" onClick={() => setShowSearchBar(true)} />
              </div>

              {isAuthenticated ? (
                <>
                  {!PublicPage && (
                    <>
                      <div className="md:block hidden">
                        <TabModule
                          handleModuleClick={handleModuleClick}
                          activeTab={activeTab}
                          theme={theme}
                        />
                      </div>
                      <RenderCreditCardDropDown
                        handleCardSelect={handleCardSelect}
                        showDropdown={showDropdown}
                        cardDataToShow={cardDataToShow}
                        cards={cards}
                        dropdownRef={dropdownRef}
                        handleCardClick={handleCardClick}
                      />
                    </>
                  )}
                </>
              ) : (
                !PublicPage && (<div className={`md:flex hidden gap-2 cursor-pointer
             ${theme !== "rewards" && "px-2 py-1 bg-white rounded-md"}`} onClick={() => navigate(CONTACT_US_PAGE)}>
                  <img src={support} alt="support" className="mt-1 w-5 h-5" loading="lazy" />

                  <div className="font-Inter text-[16px] font-medium">support</div>
                </div>)
              )}

              {!PublicPage && renderAunthenticatedWebView()}

              {!PublicPage && renderMobileViewHeaderOption()}

            </div>
          </div>
        )}

        {renderMobileSearchBarView()}

        {renderMobileMenubarView()}

        <ShowSearchBarResult
          setSearchResult={setSearchResult}
          searchTerm={searchTerm}
          SetSearchTerm={SetSearchTerm}
          setRecentSearchesState={setRecentSearchesState}
          recentSearchesState={recentSearchesState}
          resultsRef={resultsRef}
          recentSearch={recentSearch}
          searchLoading={searchLoading}
          setShowMenuMobile={setShowMenuMobile}
          setShowSearchBarMobile={setShowSearchBarMobile}
          setSearchLoading={setSearchLoading}
          setShowSearchBar={setShowSearchBar}
          showSearchBar={showSearchBar}
          searchresult={searchresult}
          PublicPage={PublicPage}
        />

        {renderLoginComponent()}

        {renderSignUpComponent()}
      </div>
    </>
  )
  );
};